import dayjs, { ConfigType } from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from 'dayjs/plugin/duration';
import "dayjs/locale/sk";

dayjs.extend(relativeTime);
dayjs.extend(duration);

export enum AvaialbleLocales {
    SLOVAK = "sk",
}

export const formatDate = (date: ConfigType, format: string = "DD.MM.YYYY", locale: AvaialbleLocales = AvaialbleLocales.SLOVAK) => {
    if (locale) {
        dayjs.locale(locale);
    }
    return dayjs(date).format(format);
}

export const getDaysCountBetweenDates = (startDate: ConfigType, endDate: Date) => {
    return dayjs(endDate).diff(dayjs(startDate), "days");
}

export const formatSeasons = (from: ConfigType, to: ConfigType): string => {
    const isSameYear = dayjs(from).isSame(to, 'year');

    if (isSameYear) {
        return formatDate(from, "D. MMM") + " - " + formatDate(to, "D. MMM, YYYY");
    }

    return formatDate(from, "D. MMM, YYYY") + " - " + formatDate(to, "D. MMM, YYYY");
}

export const formatDateTime = (date?: ConfigType) => {
    let startTime = dayjs(date);
    let dayjsToFormat = dayjs();
    if (startTime.isValid()) {
        dayjsToFormat = startTime;
    }
    if (dayjsToFormat.isSame(dayjs(), 'day')) {
        return dayjsToFormat.format('[dnes o] HH:mm');
    } else if (dayjsToFormat.isSame(dayjs(), 'month')) {
        if (dayjsToFormat.isSame(dayjsToFormat.startOf('day'))) {
            return dayjsToFormat.format('DD MMM');
        } else {
            return dayjsToFormat.format('DD MMM HH:mm');
        }
    } else if (dayjsToFormat.isSame(dayjs(), 'year')) {
        if (dayjsToFormat.isSame(dayjsToFormat.startOf('day'))) {
            return dayjsToFormat.format('DD MMM');
        } else {
            return dayjsToFormat.format('DD MMM HH:mm');
        }
    } else {
        if (dayjsToFormat.isSame(dayjsToFormat.startOf('day'))) {
            return dayjsToFormat.format('DD.MM.YYYY');
        } else {
            return dayjsToFormat.format('DD.MM.YYYY HH:mm');
        }
    }
}

export const formatRelativeTime = (date: ConfigType, locale: AvaialbleLocales = AvaialbleLocales.SLOVAK) => {
    if (locale) {
        dayjs.locale(locale);
    }
    return dayjs(date).fromNow();
}

export const formatDuration = (seconds: number) => {
    const d = dayjs.duration(seconds, 'seconds');
    const days = d.days();
    const hours = d.hours();
    const minutes = d.minutes();
    const secs = d.seconds();

    let formatted = '';
    if (days > 0) {
        formatted += `${days}d `;
    }
    if (hours > 0 || days > 0) {
        formatted += `${hours}h `;
    }
    if (minutes > 0 || hours > 0 || days > 0) {
        formatted += `${minutes}m `;
    }
    formatted += `${secs}s`;

    return formatted.trim();
}